import React, { useContext, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '@context';
import { toast } from 'react-toastify';

const ProtectedRoute = ({ children, roles }) => {
  const { auth, isLoading } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;

    if (!auth.isAuthenticated) {
      toast.info('로그인이 필요합니다.');
      navigate('/login', {
        replace: true,
        state: { from: location.pathname + location.search },
      });
      return;
    }

    if (roles && !roles.includes(auth.role)) {
      toast.info('권한이 없습니다.');
      navigate(location.key === 'default' ? '/dashboard' : -1, { replace: true });
    }
  }, [isLoading, auth, roles, navigate, location]);

  if (isLoading) return <div style={{ textAlign: 'center' }}>Loading...</div>;

  if (!auth.isAuthenticated || (roles && !roles.includes(auth.role))) {
    return null; // 리다이렉트 되기 전 하위 컴포넌트 렌더링을 막음
  }

  return children;
};

export default ProtectedRoute;